module.exports = __webpack_public_path__ + "img/order_icon.6a0a1e39.svg";